// utils/parseSSE.ts

export interface SSEMessage {
  id?: string
  event?: string
  data?: string
  retry?: string
}

/**
 * Parses an SSE chunk (multiple lines) into structured SSEMessage objects.
 * Each message is delimited by a blank line.
 *
 * @param chunk - Raw SSE text block (can include multiple messages)
 * @returns Array of SSEMessage objects
 */
export function parseSSEChunk(chunk: string): SSEMessage[] {
  
  const lines = chunk.split(/\r?\n/);
  const messages: SSEMessage[] = [];
  let current: SSEMessage = {};

  for (const line of lines) {
    if (line.trim() === "") {
      if (Object.keys(current).length > 0) {
        messages.push(current);
        current = {};
      }
      continue;
    }

    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) continue;
    
    const key = line.substring(0, colonIndex).trim();
    const value = line.substring(colonIndex + 1).replace(/^ /, "");

    if (key === "data") {
      if (current.data !== undefined) {
        // 여러 data 라인을 줄바꿈으로 연결
        current.data += "\n" + value;
      } else {
        current.data = value;
      }
    } else if (key === "event") {
      current.event = value;
    } else if (key === "id") {
      current.id = value;
    } else if (key === "retry") {
      current.retry = value;
    }
  }

  if (Object.keys(current).length > 0) {
    messages.push(current);
  }

  return messages;
}